module.exports = __webpack_public_path__ + "media/images/smart_phone/past_order_history/information_title-cc3adcf69d317ff17f766ffb89791df0.png";